export const MAX_FILE_SIZE_BYTES = 15 * 1024 * 1024;

export const MAX_BATCH_FILE_COUNT = 20;

export const MAX_FOLDER_DEPTH = 5;

export const FOLDER_DISPLAY_NAME_MAX = 120;

export const FILE_DISPLAY_NAME_MAX = 255;

export const PRESIGNED_PUT_EXPIRES_SECONDS = 900;

export const PRESIGNED_GET_EXPIRES_SECONDS = 7200;

export const CLIENT_UPLOAD_CONCURRENCY_MIN = 3;

export const CLIENT_UPLOAD_CONCURRENCY_MAX = 5;

export const DEFAULT_SYSTEM_FOLDER_COUNT = 13;
